define('plugin/facebook-business/FacebookBusinessPlugin',['require','lib/plugin/PluginAbstract','backbone','Config'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var Backbone =  require('backbone');
    var Config = require('Config');

    return PluginAbstract.extend({

        contentData: {},

        initialize: function () {
            var messagesChannel = Backbone.Wreqr.radio.channel('page');
            messagesChannel.vent.on('shown', _.bind(this.onPageChange, this));
        },

        _triggerFacebookEvent: function(eventName, additionalData){
            if(window.fbqsb && _.isFunction(window.fbqsb)) {
                var companyLogin = null;
                var companyCountry = null;
                var companyData = Config.getInstance().getOption('company');
                if(!companyData){
                    companyData = Config.getInstance().getOption('company_data');
                }
                if(companyData){
                    companyLogin = companyData.login;
                }
                if(!additionalData){
                    additionalData = {};
                }

                var businessId = Config.getInstance().getOption('fb_business_id');

                window.fbqsb('track', eventName, _.extend({
                        business_id: businessId?businessId:companyLogin,
                    }, additionalData),
                    {
                        agent: "Simplybook Ltd"
                    }
                );
            }
        },

        onPageChange: function(){
           this._triggerFacebookEvent('PageView', {

           });
        },

        onFinishBooking: function(data){
            if(data && data.confirm){  //booking is confirmed
                var addData = {
                    content_ids : data.booking_ids,
                };

                if(data && data.amount){
                    addData = _.extend(addData, {
                        currency : data.currency,
                        value : data.amount
                    });
                }

                this.contentData = addData;
                this._triggerFacebookEvent('Schedule', {});
            }
        },

        /**
         * On finish payment
         *
         * @param view
         * @param data
         * @param invoice
         */

        onFinishPayment: function (view , data, invoice) {
            var bookingIds = data.booking_ids || [];

            this.contentData = _.extend(this.contentData, {
                content_ids: bookingIds,
                currency : invoice.currency,
                value : invoice.amount
            });

            this._triggerFacebookEvent('Purchase', this.contentData);
        },

    });

});
